import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-numberseven",
  "use": "icon-th-numberseven-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-numberseven\">\n<path d=\"M21.9575 6.2875L15.9575 26.2875C15.8766 26.5359 15.7017 26.7427 15.4703 26.8638C15.2389 26.9849 14.9693 27.0107 14.7191 26.9356C14.4689 26.8604 14.2581 26.6904 14.1316 26.4619C14.0052 26.2333 13.9732 25.9643 14.0425 25.7125L19.6562 7H11C10.7348 7 10.4804 6.89464 10.2929 6.70711C10.1054 6.51957 10 6.26522 10 6C10 5.73478 10.1054 5.48043 10.2929 5.29289C10.4804 5.10536 10.7348 5 11 5H21C21.1559 5.00004 21.3096 5.03653 21.4489 5.10654C21.5881 5.17656 21.7091 5.27816 21.8021 5.40325C21.8952 5.52833 21.9577 5.67343 21.9846 5.82696C22.0116 5.98049 22.0023 6.1382 21.9575 6.2875Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-numberseven.svg
// module id = qqXw
// module chunks = 84